import { Outlet, useNavigate } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'

import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useFeatures } from 'modules/core/hooks/useFeatures'

import WorkAreasPage from 'modules/locations/pages/settings/WorkAreas'

const ProtectedWorkAreasPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { has_dev_location_work_areas } = useFeatures(['dev_location_work_areas'])
  const { moduleAvailability } = useModuleAvailability(AvailableModules.space_control)
  const spacesEnabled = moduleAvailability.available

  if (!has_dev_location_work_areas && !spacesEnabled) {
    navigate(navigation.settings.locations.fullPath())

    return null
  }

  return (
    <WorkAreasPage>
      <Outlet />
    </WorkAreasPage>
  )
}

export default ProtectedWorkAreasPage
